import * as React from 'react';
import { TDirection } from '@cian/frontend-newbuilding-carousel-component';
import { Arrow } from './parts/Arrow';
import * as styles from './ArrowControls.css';

interface IArrowControlsProps {
  disableLeft: boolean;
  disableRight: boolean;
  clickHandler?(direction: TDirection): void;
}

export function ArrowControls(props: IArrowControlsProps) {
  const { disableLeft, disableRight, clickHandler } = props;

  return (
    <div className={styles['container']}>
      <div className={styles['wrapper']}>
        <Arrow direction={-1} clickHandler={clickHandler} disabled={disableLeft} />
        <Arrow direction={1} clickHandler={clickHandler} disabled={disableRight} />
      </div>
    </div>
  );
}
